import { Button } from "@/components/ui/button";
import {
  useReadProjectGroupsOneTask,
  useUpdateProjectGroupsTasks,
} from "@/libs/react-query/hooks/useTaskQuery";
import { ReactComponent as PencilSvg } from "@/assets/images/mdi-pencil.svg";
import { useState, useRef, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function TaskEditableTitle() {
  const navigate = useNavigate();

  const [isEdit, setIsEdit] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  const { task_id = "", group_id = "" } = useParams();

  const { data: { task_title = "" } = {} } = useReadProjectGroupsOneTask(
    group_id,
    task_id
  );
  const { mutate: updateProjectGroupsTasks } = useUpdateProjectGroupsTasks({
    group_id,
    task_id,
  });

  const handleResetTitle = () => {
    setIsEdit(false);
    setInputValue(task_title);
  };

  const handleEditTitle = () => {
    setIsEdit(true);
    setTimeout(() => {
      inputRef.current?.focus();
    }, 100);
  };

  const handleSaveTitle = () => {
    setIsEdit(false);
    updateProjectGroupsTasks({ title: inputValue });
  };

  return (
    <div className="flex items-center gap-2">
      {!isEdit ? (
        <>
          <span className="text-lg font-bold text-gray-A">{task_title}</span>
          <PencilSvg
            className="size-4 cursor-pointer"
            onClick={handleEditTitle}
          />
        </>
      ) : (
        <>
          <input
            ref={inputRef}
            defaultValue={task_title}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSaveTitle();
              }
            }}
            className="min-w-fit py-1 px-4 border border-dark-red rounded-sm text-[18px] text-gray-A font-bold"
          />
          <div className="flex items-center gap-2">
            <Button
              variant="cancel"
              size="sm"
              className="text-[10px]"
              onClick={handleResetTitle}
            >
              취소
            </Button>
            <Button
              variant="confirm"
              size="sm"
              className="text-[10px]"
              onClick={handleSaveTitle}
            >
              수정
            </Button>
          </div>
        </>
      )}
    </div>
  );
}
